import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { LibraryCategory, LibraryCategoryPayload } from 'icreate/common/models/library-category';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LibraryCategoryService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByShipyardId(shipyardId: string) {
        return await lastValueFrom(
            this.http.get<LibraryCategory[]>(`${this.domain}/api/libraryCategory`, {
                headers: this.headers,
                params: { shipyardId },
            })
        );
    }

    async create(libraryCategoryData: LibraryCategoryPayload) {
        return await lastValueFrom(
            this.http.post<LibraryCategory>(`${this.domain}/api/libraryCategory`, libraryCategoryData, {
                headers: this.headers,
            })
        );
    }

    async update(libraryCategoryData: LibraryCategory) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/libraryCategory/${libraryCategoryData.id}`, libraryCategoryData, {
                headers: this.headers,
            })
        );
    }

    async deleteLibraryCategory(libraryCategoryId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/libraryCategory/${libraryCategoryId}`));
    }

    async duplicateLibraryCategory(libraryId: string, libraryCategoryData: LibraryCategory) {
        return await lastValueFrom(
            this.http.post<LibraryCategory>(`${this.domain}/api/libraryCategory/duplicate`, libraryCategoryData, {
                headers: this.headers,
                params: { libraryId },
            })
        );
    }
}
